import React, { useEffect, useRef, useState, useCallback } from "react";
import Storage from '../../common/Storage'
import { logout } from "src/redux/actions";
import useRoute from "src/common/utils/useRoute";
import { useDispatch } from "react-redux";
import IdleTimeoutDialog from './IdleTimeoutDialog'
import UserService from '../../services/UserService'
import AuthService from '../../services/AuthService'

const SessionManager = () => {
  const [idle, setIdle] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [hasUser, setHasUser] = useState(false);

  const [isInitial, setIsInitial] = useState(false);
  const [idleMessage, setIdleMessage] = useState(null);
  const [limitationMessage, setLimitationMessage] = useState(null);

  const dispatch = useDispatch();
  const { routeHomeRefresh } = useRoute();

  const idleTimerRef = useRef(null);
  const sessionTimerRef = useRef(null);
  const userTimerRef = useRef(null);

  const idleTimerValueRef = useRef(0);
  const limitationTimerValueRef = useRef(0);

  const resetIdleTimer = useCallback(() => {
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);

    if (idleTimerValueRef.current > 0) {
      idleTimerRef.current = setTimeout(() => {
        setIdle(true);
      }, idleTimerValueRef.current);
    }

  },[]);

  useEffect(() => {
    if (hasUser && isInitial === false) {
      UserService.getConfigTimeout().then(response => {

        if (response.success) {
          const idleTime = response.data.find(p => p.code === 'IdleTimeout');
          const limitationTime = response.data.find(p => p.code === 'Limitation');

          if (idleTime) {
            setIdleMessage(idleTime)
            idleTimerValueRef.current = idleTime.time * 1000;
            resetIdleTimer();
          }

          if (limitationTime) {
            setLimitationMessage(limitationTime)
            limitationTimerValueRef.current = limitationTime.time * 1000;
          }
          setIsInitial(true)
        }
      })
    }
  }, [hasUser, isInitial, resetIdleTimer])


  const handleHideIdleTime = async() => {
    setIdle(false);
    resetIdleTimer();

    const authRes = await AuthService.refreshToken();
    if (authRes.success) {
      const jwt = authRes.data;
      Storage.setJWT(jwt);
    }
  }

  const handleHideSessionTime = async() => {

    const authRes = await AuthService.refreshToken();
    if (authRes.success) {
      const jwt = authRes.data;
      Storage.setJWT(jwt);
    }

    if (sessionTimerRef.current) {
      clearTimeout(sessionTimerRef.current);
      sessionTimerRef.current = null;
    }
    setSessionExpired(false)

    if (hasUser && !sessionTimerRef.current && limitationTimerValueRef.current > 0) {
      sessionTimerRef.current = setTimeout(() => {
        setSessionExpired(true);
      }, limitationTimerValueRef.current);
    }
  }

  const handleOnLogout = () => {
    
    if (userTimerRef.current) {
      clearInterval(userTimerRef.current);
    }

    if (sessionTimerRef.current) {
      clearTimeout(sessionTimerRef.current);
    }
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
    }

    setIdle(false);
    resetIdleTimer();

    dispatch(logout(""));
    Storage.clear();
    idleTimerValueRef.current = 0;
    limitationTimerValueRef.current = 0;
    setHasUser(false);
    setIsInitial(false);

    routeHomeRefresh();
  }

  const startUserCheckInterval = (t) => {

    if (userTimerRef.current) {
      clearInterval(userTimerRef.current);
    }

    userTimerRef.current = setInterval(() => {
      const user = Storage.getUser();
      if (user?.empcode) {
        setHasUser(true);
      } else {

        if (sessionTimerRef.current) {
          clearTimeout(sessionTimerRef.current);
          sessionTimerRef.current = null;
        }

        setIdle(false)
        setSessionExpired(false)
        setHasUser(false);
      }
    }, t);
  }

  useEffect(() => {
    if (hasUser) {
      startUserCheckInterval(60000)
    } else {
      startUserCheckInterval(10000)

      if (sessionTimerRef.current) {
        clearTimeout(sessionTimerRef.current);
        sessionTimerRef.current = null;
      }
    }

    if (hasUser && !sessionTimerRef.current && limitationTimerValueRef.current > 0) {
      // ตั้ง session timeout 2 ชั่วโมง
      sessionTimerRef.current = setTimeout(() => {
        setSessionExpired(true);
      }, limitationTimerValueRef.current);
    }

    return () => {
      if (userTimerRef.current) {
        clearInterval(userTimerRef.current);
      }

      if (sessionTimerRef.current) {
        clearTimeout(sessionTimerRef.current);
      }
    }
  }, [hasUser, limitationMessage])


  const initial = useCallback(() => {

    const events = ["mousemove", "keydown", "touchstart", "scroll"];

    const user = Storage.getUser();
    
    if (user?.empcode) {
      setHasUser(true);
      events.forEach(event =>
        window.addEventListener(event, resetIdleTimer)
      );
      resetIdleTimer(); // เริ่มต้น idle timer
    }

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, resetIdleTimer)
      );
      clearTimeout(idleTimerRef.current);
    };

  }, [resetIdleTimer])

  //get user
  useEffect(() => {
    return initial();
  }, [initial]);

  return (<>
    {hasUser && idleMessage && <IdleTimeoutDialog open={idle} onClose={handleHideIdleTime} onLogout={handleOnLogout} item={idleMessage}></IdleTimeoutDialog>}
    {hasUser && limitationMessage && <IdleTimeoutDialog open={sessionExpired} onClose={handleHideSessionTime} onLogout={handleOnLogout} item={limitationMessage}></IdleTimeoutDialog>}
  </>);
}

export default SessionManager;
